import { BmsLatestValue } from "./bms-latestvalue";

export class BmsLorawanMultiMeter {
  id : string;
  name : string;
  multiMeterType : string;
  appKey : string;
  devEui : string;
  externalId : string;
  provisioned : boolean;
  deviceType : string;
  createdAt : Date;
  modifiedAt : Date;
  lastValueAt : Date;
  lastValues : BmsLatestValue[];
}
